module.exports = __webpack_public_path__ + "static/img/yinhang.e994c99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tab/yinhang.png
// module id = IkUy
// module chunks = 69